import { publicRequest, request } from '@/utils/request';

// 根据id查询商品详情
export function getUserProduct(query) {
    return request({
      url: '/base/product/info/getBySkillId',
      method: 'get',
      params: query
    })
  }